import { createStyles } from 'antd-style'

export const useStyle = createStyles(({ token }) => ({
  card: {
    height: 230,

    '& .ant-card-body': {
      height: '100%',

      '& > div': {
        height: '100%'
      }
    }
  },

  avatar: {
    backgroundColor: token.colorPrimaryBg,
    color: token.colorPrimary
  }
}))
